<div class="card" [attr.data-qa-id]="title + ' Card'">
  <header class="card-header primary-card-header" [ngClass]="headerClasses">
    {{ title }}
  </header>
  <div class="card-content" [ngClass]="contentClasses">
    <ng-content></ng-content>
  </div>
</div>
